import actionTypes from 'src/modules/redux/actionTypes'

export const setNewBanner = banner => ({
  type: actionTypes.SET_NEW_BANNER,
  payload: banner
})
